export const footerLinks = [
  {
    title: "Company",
    links: [
      {
        id: 'about-us-link',
        label: "About Us",
        url: "/about-us"
      },
      {
        id: 'how-it-works-link',
        label: "How It Works",
        url: "/how-it-works"
      },
      // {
      //   label: "Contact Us",
      //   url: "/about-us"
      // },
    ]
  },
  {
    title: "Where to Shop",
    links: [
      {
        id: 'shop-in-au-link',
        label: "Australia",
        url: "/shop-in-au?utm_source=web&utm_medium=deals&utm_campaign=ph-web-deals-australia-launch-20210309"
      },
      {
        id: 'shop-in-kr-link',
        label: "Korea",
        url: "/shop-in-kr?utm_source=website&utm_medium=header&utm_campaign=ph-web-tab-korea-shopping-20210922"
      },
      {
        id: 'shop-in-jp-link',
        label: "Japan",
        url: "/shop-in-jp?utm_source=web&utm_medium=banner&utm_campaign=shop-in-japan20210120"
      },
      // {
      //   id: 'shop-in-uk-link',
      //   label: "United Kingdom",
      //   url: "/shop-in-uk"
      // },
      {
        id: 'shop-in-us-link',
        label: "United States",
        url: "/shop-in-us"
      },
    ]
  },
  {
    title: "Help Center",
    links: [
      {
        id: 'faqs-link',
        label: "FAQs",
        url: "https://help-center.shippingcart.com/hc/en-us",
        external: true,
      },
      {
        id: 'special-handling-link',
        label: "Special Handling",
        url: "/special-handling"
      },
      {
        id: 'prohibited-items-link',
        label: "Prohibited Items",
        url: "/prohibited-items"
      },
    ]
  },
  {
    title: "Social Media",
    links: [
      {
        id: 'fb-link',
        label: "Facebook",
        url: "https://www.facebook.com/ShippingCartCom",
        external: true,
        target: '_blank',
        icon: 'https://cdn.shippingcart.com/assets/facebook-20221005084929.svg'
      },
      {
        id: 'instagram-link',
        label: "Instagram",
        url: "https://www.instagram.com/shippingcart",
        external: true,
        target: '_blank',
        icon: 'https://cdn.shippingcart.com/assets/instagram-20221005084935.svg'
      },
      {
        id: 'youtube-link',
        label: "YouTube",
        url: "https://www.youtube.com/c/ShippingCart",
        external: true,
        target: '_blank',
        icon: 'https://cdn.shippingcart.com/assets/youtube-20221005084942.svg'
      },
      {
        id: 'twitter-link',
        label: "X (formerly Twitter)",
        url: "https://x.com/shippingcart?utm_source=website&utm_medium=footer&utm_campaign=ph-web-footer",
        external: true,
        target: '_blank',
        icon: 'https://cdn.shippingcart.com/assets/twitter_default-20250804103302.svg'
      },
      {
        id: 'tiktok-link',
        label: "TikTok",
        url: "https://bit.ly/3SgbGNZ",
        external: true,
        target: '_blank',
        icon: 'https://cdn.shippingcart.com/assets/tiktok-20221005083352.svg'
      },
    ]
  },
]


/** WEBPACK FOOTER **
 ** ./src/components/Layout/Footer/constant.js
 **/